import React, { useEffect, useState } from 'react'
import { useFeiyongTypeListQuery } from '../../store/NeiZhangFeiYongApi';
import { Form, Select } from 'antd';
import ExpenseTypeEdit from './ExpenseTypeEdit';

function ExpenseTypeSelect(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useFeiyongTypeListQuery({fyt_qy_id:props.e_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {fyt_id,fyt_name }=item;
                    return item = {value:fyt_id,label:fyt_name }
                })
                setList(newArr)
            }else{
                setList([])
            }
        }
    },[data,isSuccess])
    return (
        <Form.Item 
            label={props.label} 
            required  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
            name={props.name}
            tooltip={{title:<ExpenseTypeEdit e_id={props.e_id}  eu_id={props.eu_id}  eu_name={props.eu_name} />,color:'#fff'}}
        >
            <Select 
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                defaultValue={props.defaultId}
                placeholder={props.placeholder}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />                
        </Form.Item>
    )
}

export default ExpenseTypeSelect